// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Logo":"Footer_Logo__LAFqE","Social":"Footer_Social__1TBls"};